<template>
  <div class="menu" :style="{height: availHeight,}">
    <!-- 曲線圖 -->
    <div class="mock-up">
      <div class="overlay">
        <!-- <img src="../img/louisa.png" > -->
      </div>
    </div>
    <div id="layer" v-if="loading"/>
    <!-- 沒有品項 -->
    <div class="box" v-show="shopCart.length === 0">
      <div class="dia">
        <div style="transform: scale(5); width: 50px; height: 20px;margin: 35px auto; margin-top: 30px;">
          <i class="cubeic-warn"></i><br><br>
        </div>
        <span style="color: #3F3F3F;">購物車目前無商品，請選擇門市進行消費。</span>
      </div>
    </div>

    <!-- 購物車品項 -->
    <div class="box" v-show="shopCart.length !== 0">
      <cube-loading :size="35" class="loading" v-if="loading"></cube-loading>
      <div class="item-box">
        <ul class="list">
          <div class="item" style="height: 30px;">
            <div class="left">
              <li class="title" style="margin-top: -20px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">品項訂單</span>
              </li>
            </div>
            <div class="right" style="color:#454545; margin-top: -20px; margin-left: -10px;" @click="emptyCart">
              <li class="title" style=" margin-left: 0px;"><i style="margin: 20px 7px; background-color: #ed9528 ;border-radius: 50%; color: #ffffffff; transform: scale(1.1);" class="cubeic-delete"></i>清空</li>
            </div>
          </div>
          <div class="item" v-for="(item, index) in shopCart" :key="index" >
            <input type="checkbox" class="checkbox" :value="item" v-model="checkList">
            <div class="left" style="width: 80px; margin-left: 20px;">
              <img :src="item.img" width="95%" height="65px" style="border-radius:3px; margin-left: -5px;" >
            </div>
            <!-- 飲品 -->
            <div class="middle" style="width:160px; margin-left: 0px; margin-top: -5px" v-if="item.type === '飲品'">
              <li class="title">{{ item.title }}</li>
              <li class="entitle">{{ item.size }}/{{ item.iceSelect }}/{{ item.sugarSelect }}</li>
              <li class="money">NT.{{ item.item_price * item.num }}</li>
            </div>
            <!-- 食物 -->
            <div class="middle" style="width:160px; margin-left: 0px; margin-top: -5px" v-if="item.type === '食物'">
              <li class="title">{{ item.title }}</li>
              <li class="entitle" style="height:15px;">{{ item.foodSelect.toString() }} {{ item.drinkSelect.toString() }} {{ item.iceSelect }}/{{ item.sugarSelect }}</li>
              <li class="money">NT.{{ item.f_price * item.num }}</li>
            </div>
            <div class="right" style="width:100px; transform: scale(1.2) translateY(15px); ">
              <i class="cubeic-remove"  @click="minus(index)"/> <div style="color: black; display: inline-block; text-align:center; transform: scale(0.9) translateY(-1px); width:30px; height: 5px;line-height: 10px;">{{ item.num }}</div> <i  class="cubeic-add" @click="plus(index)"/>
            </div>
          </div>
          <div class="item" style="height: 50px;">
            <div class="left">
              <li class="title" style="width: 80px; margin-left: 0px;">
                <div style="margin-top: 0px; margin-left: 15px; transform: scale(1);color:#2b2b2b; font-weight: 500;">折抵點數</div>
              </li>
            </div>
            <div class="middle" style="width:205px; margin-left: 0px; margin-top: -16px">
            </div>
            <div class="right" style="width:100px; transform: scale(1.2) translateX(0px); ">
              <i class="cubeic-remove"  @click="MinusCalPoints()"/> <div style="color: black; display: inline-block; text-align:center; transform: scale(0.9) translateY(-1px); width:30px; height: 5px;line-height: 10px;">{{ redeemP }}</div> <i  class="cubeic-add" @click="PlusCalPoints()"/>
            </div>
          </div>
          <div class="item" style="height: 50px;">
            <div class="left">
              <li class="title" style="margin-top: 0px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">目前點數</span>
              </li>
            </div>
            <div class="middle" style="width:160px; margin-left: 0px; margin-top: -16px">
            </div>
            <div class="right" style="width:100px; transform: scale(1.1) translateX(-13px); text-align: center;">
              <li class="money" style="color:black; font-weight: 500; left: 0px;" > {{  points }} </li>
            </div>
          </div>
          <div class="item" style="height: 50px;">
            <div class="left">
              <li class="title" style="width: 80px; margin-left: 0px;">
                <div style="margin-top: 0px; margin-left: 15px; transform: scale(1);color:#2b2b2b; font-weight: 500;">取貨時間</div>
              </li>
            </div>
            <div class="middle" style="width:80px; margin-left: 0px; margin-top: 0px ;font-weight: 500;">{{ showTime }}
            </div>
            <div class="right" style="width:80px; transform: scale(1.2) translateY(0px); ">
              <i class="cubeic-time" style="color:transparent;"/> <div style="display: inline-block; text-align:center; transform: scale(1.2) translateY(-1px); width:30px; height: 5px;line-height: 10px;"> <i class="cubeic-time" @click="showTimePicker"/></div> <i  class="cubeic-add" style="color:transparent;"/>
            </div>
          </div>
          <div class="item" style="height: 50px;">
            <div class="left">
              <li class="title" style="margin-top: 0px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">統一編號</span>
              </li>
            </div>
            <div class="middle">
              <li class="title" style="width: 180px;"><cube-input v-if="SID === true" v-model="SIDForm" :maxlength="8" placeholder="請輸入.." style="border: none;" ></cube-input></li>
            </div>
            <div class="right" style="margin-top: 0px; margin-left: -10px;">
              <li class="title"  style=" margin-left: 10px;"><cube-switch v-model="SID"/></li>
            </div>
          </div>
          <div class="item" style="height: 50px;">
            <div class="left">
              <li class="title" style="margin-top: 0px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">備註</span>
              </li>
            </div>
            <div class="middle">
              <li class="title" style="width: 180px;"><cube-input v-if="openNote === true" v-model="note" :maxlength="30" placeholder="請輸入.." style="border: none;" ></cube-input></li>
            </div>
            <div class="right" style="margin-top: 0px; margin-left: -10px;">
              <li class="title"  style=" margin-left: 10px;"><cube-switch v-model="openNote"/></li>
            </div>
          </div>
          <div class="item" style="height: 50px;">
            <div class="left">
              <li class="title" style="margin-top: 0px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">取貨門市</span>
              </li>
            </div>
            <div class="middle">
              <li class="title" style="width: 175px;">{{ shop }} </li>
            </div>
            <div class="right" style="color:#454545; margin-top: 0px; margin-left: -10px;">
              <li class="title"  style=" margin-left: 0px;"></li>
            </div>
          </div>
          <div class="item" style="height: 50px;">
            <div class="left">
              <li class="title" style="margin-top: 0px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">折扣前金額</span>
              </li>
            </div>
            <div class="middle" style="width:217px; margin-left: 0px; margin-top: -16px">
              <li class="money" style="color:black; font-weight: 500;" > NT.{{  withoutDiscount() }} </li>
            </div>
          </div>
          <div class="item" style="height: 50px; border:none; ">
            <div class="left">
              <li class="title" style="margin-top: 0px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">總金額</span>
              </li>
            </div>
            <div class="middle" style="width:10px; margin-left: 0px; margin-top: -16px">
              <li class="money" style="color:black; font-weight: 500;" > NT.{{  totalPrice() }} </li>
            </div>
            <div class="right" style="color:#454545; margin-top: 0px; margin-left: 55px;" @click="beforeSendOrder">
              <li class="title"  style=" margin-left: 0px;"><cube-button class="bottom_right_button"  :primary="true">送出訂單</cube-button></li>
            </div>
          </div>
        </ul>
      </div>
      <!-- <div class="box2">
        <div class="item-box2" style="height: 75px; width: 100%; top: 25px; border-radius: 0px; overflow-y: none;">
          <ul class="list">
            <div class="item" style="border:none;">
              <div class="left">
                <li class="title" style="margin-top: 0px;">
                  <span style="margin-top: 0px; margin-left: 0px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">總金額</span>
                </li>
              </div>
              <div class="middle" style="width:40px; margin-left: 0px; margin-top: -0px">
                <li class="money" style="color:black; font-weight: 500;" > NT.{{  totalPrice() }} </li>
              </div>
              <div class="right" style="color:#454545; margin-top: 0px; margin-left: 0px;" @click="beforeSendOrder">
                <li class="title"  style=" margin-left: 0px;"><cube-button class="bottom_right_button"  :primary="true">送出訂單</cube-button></li>
              </div>
            </div>
          </ul>
        </div>
      </div> -->
    </div>

    <!-- 結帳 -->
    <!-- <div class="box2" v-if="payment === true">
      <div class="item-box">
        <ul class="list">
          <div class="item" style="height: 30px;">
            <div class="left">
              <li class="title" style="margin-top: -20px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">品項訂單確認</span>
              </li>
            </div>
            <div class="right" style="margin-top: -20px; margin-left: -10px;" @click="closePayment">
              <li class="title" style=" margin-left: 0px;"><i style="margin: 20px 7px; background-color: #ed9528 ;border-radius: 50%; color: #ffffffff; transform: scale(1.1);" class="cubeic-wrong"></i></li>
            </div>
          </div>
          <div class="item" v-for="(item, index) in checkList" :key="index" >
            <div class="left" style="width: 80px; margin-left: 20px;">
              <img :src="item.img" width="95%" height="65px" style="border-radius:3px; margin-left: -5px;" >
            </div>

            <div class="middle" style="width:160px; margin-left: 0px; margin-top: -5px" v-if="item.type === '飲品'">
              <li class="title">{{ item.title }}</li>
              <li class="entitle">{{ item.size }}/{{ item.iceSelect }}/{{ item.sugarSelect }}/{{'x' + item.num}}</li>
              <li class="money">NT.{{ item.item_price  }}</li>
            </div>

            <div class="middle" style="width:160px; margin-left: 0px; margin-top: -5px" v-if="item.type === '食物'">
              <li class="title">{{ item.title }}</li>
              <li class="entitle" style="height: 15px;">{{ item.foodSelect.toString() }} {{ item.drinkSelect.toString() }} / {{'x' + item.num}}</li>
              <li class="money">NT.{{ item.f_price * item.num }}</li>
            </div>
            <div class="right" style="width:100px; transform: scale(1.2) translateY(-8px); " v-if="item.type === '飲品'">
              <div class="money" style="transform: scale(1) translateY(4px); width: 50px; height: 5px;line-height: 10px;">NT.{{ item.item_price * item.num  }}</div>
            </div>
            <div class="right" style="width:100px; transform: scale(1.2) translateY(-8px); " v-if="item.type === '食物'">
              <div class="money" style="transform: scale(1) translateY(4px); width: 50px; height: 5px;line-height: 10px;">NT.{{ item.f_price * item.num  }}</div>
            </div>
          </div>
          <div class="item" style="height: 50px;">
            <div class="left">
              <li class="title" style="margin-top: 0px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">取貨門市</span>
              </li>
            </div>
            <div class="middle">
              <li class="title" style="width: 200px;">{{ shop }} </li>
            </div>
            <div class="right" style="color:#454545; margin-top: 0px; margin-left: -10px;">
              <li class="title"  style=" margin-left: 0px;"></li>
            </div>
          </div>
          <div class="item" style="height: 50px; border:none;">
            <div class="left">
              <li class="title" style="margin-top: 0px;">
                <span style="margin-top: 0px; margin-left: 15px; transform: scale(1.1);color:#2b2b2b; font-weight: 500;">總金額</span>
              </li>
            </div>
            <div class="middle">
              <li class="title" style="margin-left: 15px; width: 50px;">{{ 'NT' + '.' + totalPrice() }} </li>
            </div>
            <div class="right" style="color:#454545; margin-top: 0px; margin-left: 55px;" @click="sendOrder">
              <li class="title"  style=" margin-left: 0px;"><cube-button class="bottom_right_button"  :primary="true">送出訂單</cube-button></li>
            </div>
          </div>
        </ul>
      </div>
    </div> -->


  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      showTime: '',
      selectedTime: '',
      openNote: false,
      note: '',
      loading: false,
      SID: false,
      SIDForm: '',
      shop: localStorage.getItem('locatedShop'),
      shopNo: localStorage.getItem('locatedShopNum'),
      payment: false,
      availHeight: document.documentElement.offsetHeight,
      redeemP: 0,
      tempPrice: [],
      checkList: [],
      finalList: [],
      index: '',
    }
  },
  props: ['eid','userName','phone', 'points'],
  mounted() {
    this.checkList = this.shopCart
    console.log( " 網頁可見區域高："+ document.body.clientHeight)
    console.log( " 螢幕解析度的高："+ window.screen.height)
    console.log( " 螢幕可用工作區高度："+ window.screen.availHeight)
    console.log( this.availHeight);

    // this.shopCar = this.checkList;
    // console.log(this.shopCart);
    // console.log(this.imCart);
  },
  watch: {
    SIDForm(val) {
      console.log(val);
      var reg = /^[0-9]+$/
      if (!reg.test(val)) {
        alert('請輸入數字');
        this.SIDForm = '';
      }
       else if (val.match(/^\d{8}$/)) {
        this.checkTB(val);
      }
    },
    SID (val) {
      // console.log(val);
      if (val === false) {
        this.SIDForm = ''
      }
    },
    checkList(val) {
      // console.log(val.filter(el => el.AreaType !== 'C' || el.AreaType !== 'B').length);
      const a = val.filter(el => el.AreaType !== 'C' || el.AreaType !== 'B').length
      if (a !== !a) {
        this.redeemP = 0;
      }
    }
  },
  computed: {
    ...mapGetters({
      shopCart: 'shopCart',
      imCart: 'imCart',
    }),
    total() {
      // onsole.log(this.checkList);
      const standardPrice = this.checkList.filter(el => el.Areatype !== 'C')
      let totalPrice = 0;
      let totalFoodPrice = 0;
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i].type === '飲品') {
          totalPrice += parseInt(this.checkList[i].item_price) * this.checkList[i].num;
        } else {
          totalFoodPrice += parseInt(this.checkList[i].f_price) * this.checkList[i].num
        }
      }
      const combine = totalPrice + totalFoodPrice;
      return combine;
    },
    totalF() {
      // console.log(this.checkList);
      let totalFoodPrice = 0;
      for (let i = 0; i < this.checkList.length; i++) {
        totalFoodPrice += parseInt(this.checkList[i].f_price) * this.checkList[i].num
      }
      return totalFoodPrice;
    },
    shopCar: {
      get () { return this.shopCart },
      set (value) { this.updateShopCart({ shopCart: value }); },
    },
  },
  methods: {
  ...mapActions({
    deleteUser: 'deleteUser',
    sendOrderEilis: 'sendOrderEilis',
    getAccessToken: 'getAccessToken',
    sendOrderVenus: 'sendOrderVenus'
  }),
  ...mapMutations({
    updateShopCart: 'updateShopCart'
  }),
    checkTB(val){
      var tbNum = new Array(1,2,1,2,1,2,4,1);
      var temp = 0;
      var total = 0;
        for(var i = 0; i < tbNum.length ;i ++){
            temp = val.charAt(i) * tbNum[i];
            total += Math.floor(temp/10)+temp%10;
        }
        if(total%10==0 || (total%10==9 && val.charAt(6)==7))
          alert('營利事業統一編號正確!');
          else alert('營利事業統一編號錯誤!');
          this.SIDForm = '';
    },
    showTimePicker () {
      const arr = []
      const a = new Date(Date.now()+1000*60*15).getHours().toString();
      console.log(a);
      const b = new Date(Date.now()+1000*60*15).getMinutes().toString();
      console.log(b);
      arr.push(a,b)
      console.log(arr);
      this.$createDatePicker({
        min: arr,
        max: [22,30],
        cancelTxt: '取消',
        confirmTxt: '確定',
        subtitle: '',
        value: new Date(),
        columnCount: 2,
        title: '選擇時間',
        startColumn: 'hour',
        showNow: false,
        delay: 30,
        day: {
          len: 1,
          filter: ['今天'],
          // format: 'M月d日'
        },
        onSelect: (selectedTime, selectedText, formatedTime) => {
          const dhours = new Date(selectedTime).getHours().toString() < 10 ? `0${new Date(selectedTime).getHours().toString()}` : new Date(selectedTime).getHours().toString();
          const dmts = new Date(selectedTime).getMinutes().toString() < 10 ? `0${new Date(selectedTime).getMinutes().toString()}` : new Date(selectedTime).getMinutes().toString();
          const dseconds = new Date(selectedTime).getSeconds().toString() < 10 ? `0${new Date(selectedTime).getSeconds().toString()}` : new Date(selectedTime).getSeconds().toString()
          this.selectedTime = dhours+dmts+dseconds;
          this.showTime = dhours + ':' + dmts
          // this.$createDialog({
          //   type: 'warn',
          //   title: `selected time: ${selectedTime}`,
          //   content: `selected text: ${selectedText}<br>format time: ${formatedTime}`,
          //   icon: 'cubeic-alert'
          // }).show()
        },
        // onCancel: () => {
        //   this.$createToast({
        //     type: 'correct',
        //     txt: 'Picker canceled',
        //     time: 1000
        //   }).show()
        // }
      }).show()
    },
    list() {
      // console.log(this.checkList);
      let emptyList = [];
      for (let i = 0; i < this.checkList.length; i += 1) {
        for (let e = 0; e < this.checkList[i].num; e += 1) {
          // emptyList.push(parseInt(this.checkList[i].item_price))
          if (this.checkList[i].AreaType !== 'C' && this.checkList[i].AreaType !== 'B' && this.checkList[i].AreaType !== 'D') {
            emptyList.push(parseInt(this.checkList[i].item_price) ? parseInt(this.checkList[i].item_price) : parseInt(this.checkList[i].f_price))
          }
        }
      }
      return emptyList;
    },
    listC() {
      // console.log(this.checkList);
      let emptyList = [];
      for (let i = 0; i < this.checkList.length; i += 1) {
        for (let e = 0; e < this.checkList[i].num; e += 1) {
          // emptyList.push(parseInt(this.checkList[i].item_price))
          if (this.checkList[i].AreaType === 'C' || this.checkList[i].AreaType === 'B' || this.checkList[i].AreaType === 'D') {
            emptyList.push(parseInt(this.checkList[i].item_price) ? parseInt(this.checkList[i].item_price) : parseInt(this.checkList[i].f_price))
          }
        }
      }
      return emptyList;
    },
    withoutDiscount() {
      const array = this.list().sort((a, b) => b - a);
      const arrayC = this.listC().sort((a, b) => b - a);
      const discountCup = this.redeemP / 3;
      let origin = 0;
      let arrayCorigin = 0;
      for (let i = 0; i < array.length; i += 1) {
          origin += array[i];
      }
      for (let e = 0; e < arrayC.length; e += 1) {
        arrayCorigin += arrayC[e]
      }
      return origin + arrayCorigin;
    },
    totalPrice() {
      const array = this.list().sort((a, b) => b - a);
      const arrayC = this.listC().sort((a, b) => b - a);
      // console.log(array);
      // console.log(arrayC);
      const discountCup = this.redeemP / 3;
      let origin = 0;
      let arrayCorigin = 0;
      for (let i = 0; i < array.length; i += 1) {
        if (i <= discountCup - 1) {
          origin += Math.round(array[i] * 0.9);
        }
        else {
          origin += array[i];
          // console.log(origin);
        }
      }
      for (let e = 0; e < arrayC.length; e += 1) {
        arrayCorigin += arrayC[e]
      }
      return origin + arrayCorigin;
    },
    PlusCalPoints() {
      const array = this.list().sort((a, b) => b - a);
      // console.log(array);
      if ((this.redeemP + 3) <= this.points) {
        const typeC = this.listC().sort((a, b) => b - a);
        // console.log(typeC);
        if (this.redeemP + 3 <= array.length * 3) {
          this.redeemP += 3;
        }
        else if (this.redeemP + 3 <= this.shopCart.length * 3) {
          // const typeC = this.listC().sort((a, b) => b - a);
          // console.log(typeC);
          if (this.checkList.length > 0 && typeC.length < 1) {
            if (this.redeemP + 3 > this.checkList.length * 3) {
              this.$createDialog({
                type: 'confirm',
                title: '系統通知',
                content: '請點選所需品項',
                icon: 'cubeic-alert',
                confirmBtn: {
                  text: '確定',
                  active: true,
                  disabled: false,
                  href: 'javascript:;'
                },
              }).show()
            } else {
              this.redeemP += 3;
            }
          } else if (this.checkList.length > 0 && typeC.length > 0) {
            if (this.redeemP + 3 > (this.checkList.length * 3 - typeC.length * 3)) {
              this.$createDialog({
                type: 'confirm',
                title: '系統通知',
                content: '餐點跟套餐及黑卡特價無法折抵',
                icon: 'cubeic-alert',
                confirmBtn: {
                  text: '確定',
                  active: true,
                  disabled: false,
                  href: 'javascript:;'
                },
              }).show()
            } else {
              this.redeemP += 3;
            }
          }
          else if (this.redeemP + 3 > this.checkList.length * 3) {
            this.$createDialog({
              type: 'confirm',
              title: '系統通知',
              content: '請點選所需品項',
              icon: 'cubeic-alert',
              confirmBtn: {
                text: '確定',
                active: true,
                disabled: false,
                href: 'javascript:;'
              },
            }).show()
          } else {
            this.redeemP += 3;
          }
        }
      }
    },
    MinusCalPoints() {
      if (this.redeemP !== 0) {
        this.redeemP -= 3;
      }
    },
    final() {
      let arr = [];
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.shopCart.indexOf(this.checkList[i]) !== -1) {
          arr.push(this.checkList[i])
        }
      }
      this.finalList = arr;
      // console.log(this.finalList);
      // for (let i = 0; i < this.checkList.length; i++) {
      //   this.shopCart.filter(el => el.num * el.item_price === this.checkList[i].num * this.checkList[i].item_price)
      // }
    },
    beforeSendOrder() {
      if (this.checkList.length < 1) {
        this.$createDialog({
          type: 'confirm',
          title: '系統通知',
          content: '還未點選所需品項',
          icon: 'cubeic-alert',
          confirmBtn: {
            text: '確定',
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
        }).show()
      } else if (this.selectedTime === '') {
        this.$createToast({
          type: 'correct',
          txt: '取貨時間必填',
          time: 1000
        }).show()
      }
      else {
        this.$createDialog({
          type: 'confirm',
          title: '系統通知',
          content: '確認訂單送出嗎？',
          icon: 'cubeic-alert',
          confirmBtn: {
            text: '確定',
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {
            this.sendOrder()
          },
        }).show()
      }
    },
    sendOrder() {
      this.loading = true;
      // this.$createDialog({
      //   type: 'alert',
      //   showClose: false,
      //   content: '你的訂單已成功送出，請前往訂單查看',
      //   // text: '你的訂單已成功送出，請前往訂單查詢查看',
      //   onConfirm: () => {
      //     setTimeout(() => {
      //       // if (this.shopCart.length > 0 || this.imCart.length > 0) {
      //       //   this.shopCar = [];
      //       //   this.imCart = []
      //       // }
      //       this.$emit('gotoList', '訂單');
      //     },500)
      //   }
      // }).show()
      // return;
      const form1 = [{name: { title: '熱', num: '0003'} },  {name: { title: '全冰', num: '0102'} }, {name: { title: '七分冰', num: '0103'} }, { name: { title: '五分冰', num: '0104'} }, {name: { title: '三分冰', num: '0105'} }, {name: { title: '去冰', num: '0106' } }, {name: { title: '全糖', num: '0302'} }, {name: { title: '七分糖', num: '0303'} },{name: { title: '五分糖', num: '0304'} }, {name: { title: '三分糖', num: '0305'}}, {name: { title: '無糖', num: '0306'}}, {name: { title: '起司', num: '3103'}} , {name: { title: '歐姆蛋', num: '3501'}}]
      const form = [{name: '熱', num: '0003'}, {name: '全冰', num: '0102'}, {name: '七分冰', num: '0103'}, {name: '五分冰', num: '0104'}, {name: '三分冰', num: '0105'}, {name: '去冰', num: '0106'}, {name: '全糖', num: '0302'}, {name: '七分糖', num: '0303'},{name: '五分糖', num: '0304'}, {name: '三分糖', num: '0305'}, {name: '無糖', num: '0306'}]
      // console.log(this.shop);
      // console.log(this.checkList)
      // console.log(this.withoutDiscount())
      // console.log(this.checkList.drinkSelect.indexOf('加奶茶'));
      let list1 = []
      let list2 = []
      let list3 = []
      for (let e = 0; e < this.checkList.length; e++) {
        if (this.checkList[e].AreaType === 'C') {
            list1[e] = {
              // recno: 1+e,
              p_no: '0001',
              sl_price: this.checkList[e].f_price,
              sl_qty: '2',
              sl_amt: this.checkList[e].f_price,
              sl_disc_amt: '0',
              sl_taxamt: this.checkList[e].f_price,
              sl_notaxamt: '0',
              p_type: '1',
              pk_recno: '0001',
              p_qty: '1'
            },
            list2[e] = {
              // recno: 1+e+`${Math.floor(Math.random()*(9-0+1))}`+`${Math.floor(Math.random()*(9-0+2))}`+`${Math.floor(Math.random()*(9-0+2))}`,
              p_no: this.checkList[e].itemNumber,
              sl_price: this.checkList[e].drinkSelect.indexOf('加奶茶') !== -1 ? this.checkList[e].f_price - 20 : this.checkList[e].f_price - 15,
              sl_qty: '1',
              sl_amt: this.checkList[e].drinkSelect.indexOf('加奶茶') !== -1 ? (this.checkList[e].f_price - 20) -  (Math.round(((5 * (this.checkList[e].f_price - 20)) / (this.checkList[e].f_price + 5))))  : (this.checkList[e].f_price - 15) - (Math.round((5 * (this.checkList[e].f_price - 15) / (this.checkList[e].f_price  + 5)))),
              sl_disc_amt: '0',
              sl_taxamt: this.checkList[e].drinkSelect.indexOf('加奶茶') !== -1 ? (this.checkList[e].f_price - 20) - (Math.round(((5 * (this.checkList[e].f_price - 20)) / (this.checkList[e].f_price + 5))))  : (this.checkList[e].f_price - 15) - (Math.round((5 * (this.checkList[e].f_price - 15) / (this.checkList[e].f_price  + 5)))),
              sl_notaxamt: '0',
              p_type: '2',
              pk_recno: this.checkList[e].itemNumber,
              p_qty: '1',
              pk_add_price: "0"
            }
            list3[e] = {
              // recno: 1+e+`${Math.floor(Math.random()*(9-1+1))}`+`${Math.floor(Math.random()*(9-1+1))}`,
              p_no: this.checkList[e].drinkSelect.indexOf('加奶茶') !== -1 ? '050218-2' : '050218-1',
              sl_price: this.checkList[e].drinkSelect.indexOf('加奶茶') !== -1 ? '25' : '20',
              sl_qty: '1',
              sl_amt: this.checkList[e].drinkSelect.indexOf('加奶茶') !== -1 ? 25 - (Math.round((5 * 25) / (this.checkList[e].f_price + 5))) : 20 - (Math.round((5 * 20 / (this.checkList[e].f_price + 5)))),
              sl_disc_amt: '0',
              sl_taxamt: this.checkList[e].drinkSelect.indexOf('加奶茶') !== -1 ? 25 - (Math.round((5 * 25) / (this.checkList[e].f_price + 5))) : 20 - (Math.round((5 * 20 / (this.checkList[e].f_price + 5)))),
              sl_notaxamt: '0',
              p_type: '2',
              pk_recno: this.checkList[e].drinkSelect.indexOf('加奶茶') !== -1 ? '050218-2' : '050218-1',
              p_qty: '1',
              pk_add_price: "0",
              sea: {
                sea_no: form1.filter(el => el.name.title === this.checkList[e].iceSelect)[0].name.num + '/' + form1.filter(el => el.name.title === this.checkList[e].sugarSelect)[0].name.num,
                sea_amt: 0
              }
            }
        } else {
          list1[e] = {
            // recno: 1+e,
            p_no: this.checkList[e].size === 'M' && this.checkList[e].itemNumber2 ? this.checkList[e].itemNumber2 : this.checkList[e].itemNumber ,
            sl_price: this.checkList[e].item_price ? this.checkList[e].item_price * this.checkList[e].num : this.checkList[e].f_price * this.checkList[e].num,
            sl_qty: this.checkList[e].num,
            sl_amt: this.checkList[e].item_price ? this.checkList[e].item_price * this.checkList[e].num : this.checkList[e].f_price * this.checkList[e].num,
            sl_disc_amt: '0',
            sl_taxamt: this.checkList[e].item_price ? this.checkList[e].item_price * this.checkList[e].num : this.checkList[e].f_price * this.checkList[e].num,
            sl_notaxamt: 0,
            // pk_recno: 2,
            // p_qty: 3,
            p_type: '0',
            sea: {
              // sea_no: this.checkList[e].foodSelect['歐姆蛋'] ? '3501' : this.checkList[e].foodSelect['起司'] ? '3401' : this.checkList[e].foodSelect['歐姆蛋']['起司'] ? '3501' + '3401': '',
              sea_no: this.checkList[e].iceSelect ? form1.filter(el => el.name.title === this.checkList[e].iceSelect)[0].name.num + '/' + form1.filter(el => el.name.title === this.checkList[e].sugarSelect)[0].name.num : this.checkList[e].foodSelect.indexOf('起司','歐姆蛋') ? '3501' + '/' +'3401' : this.checkList[e].foodSelect.indexOf('歐姆蛋') ? '3501' : this.checkList[e].foodSelect.indexOf('起司') ? '3401' : '',
              sea_amt: this.checkList[e].iceSelect ? 0 : this.checkList[e].foodSelect.indexOf('起司','歐姆蛋') ? 20 : this.checkList[e].foodSelect.indexOf('歐姆蛋') ? 10 : this.checkList[e].foodSelect.indexOf('起司') ? 10 : '',
            }
          }
        }
      }
      const totalArr = list1.concat(list2,list3).filter(item => item)
      // console.log(totalArr);
      let finalArr = totalArr
      for (let v = 0; v < totalArr.length; v += 1) {
        finalArr[v].recno = v + 1
      }
      console.log(finalArr);
      // console.log(this.SIDForm);
      return;
      const Year = new Date().getFullYear().toString();
      const Month = (new Date().getMonth()+1).toString() < 10 ? `0${(new Date().getMonth()+1).toString()}` : (new Date().getMonth()+1).toString();
      const Day = new Date().getDate().toString() < 10 ? `0${new Date().getDate().toString()}` : new Date().getDate().toString();
      const hours = new Date().getHours().toString() < 10 ? `0${new Date().getHours().toString()}` : new Date().getHours().toString();
      const mts = new Date().getMinutes().toString() < 10 ? `0${new Date().getMinutes().toString()}` : new Date().getMinutes().toString();
      const second = new Date().getSeconds().toString() < 10 ? `0${new Date().getSeconds().toString()}` : new Date().getSeconds().toString();
      const dhours = new Date(Date.now()+30*60*1000).getHours().toString() < 10 ? `0${new Date(Date.now()+30*60*1000).getHours().toString()}` : new Date(Date.now()+30*60*1000).getHours().toString();
      const dmts = new Date(Date.now()+30*60*1000).getMinutes().toString() < 10 ? `0${new Date(Date.now()+30*60*1000).getMinutes().toString()}` : new Date(Date.now()+30*60*1000).getMinutes().toString();
      const dseconds = new Date(Date.now()+30*60*1000).getSeconds().toString() < 10 ? `0${new Date(Date.now()+30*60*1000).getSeconds().toString()}` : new Date(Date.now()+30*60*1000).getSeconds().toString()
      let totalMount = 0
      let totalF_Mount = 0
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i].type === '飲品') {
          totalMount += this.checkList[i].num * parseInt(this.checkList[i].item_price)
        } else {
          totalF_Mount += this.checkList[i].num * parseInt(this.checkList[i].f_price)
        }
      }
      const orderNum = `${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}` + Date.now() + `${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}`;
      const total = totalMount + totalF_Mount
      console.log(dhours+dmts+dseconds);
      this.sendOrderVenus({
        sl_invid: this.SIDForm,
        s_no: 'Z9999', // 門市編號 //Z9999
        sl_date: Year+Month+Day, // 發票日期
        sl_time: hours+mts+second, // 交易產生時間
        c_no: this.eid.substr(2,), // 會員編號
        dlvr_date: Year+Month+Day, // 預交日期
        dlvr_time: this.selectedTime, // 預交時間
        c_name: this.userName, // 寫入會員姓名
        c_tel1: this.phone, // 寫入聯絡電話
        sl_qty: finalArr.length === 1 ? finalArr[0].sl_qty : finalArr.length,
        sl_amt: this.withoutDiscount(),
        sl_disc_amt: this.withoutDiscount() - this.totalPrice(),
        sl_taxamt: this.withoutDiscount(),
        sl_notaxamt: 0,
        pay_amt: 0,
        pay_status: '0',
        pick_mode: '1',
        s_no_out: 'Z9999', // 出貨門市
        payment_id: '01', // 付款方式:01 現金 02 信用卡 03 禮券...
        sl_platform: '5',
        od_no: orderNum,
        sao_d: finalArr,
        remark_String: this.note,
      })
      .then((res) => {
        if (res.data.code !== '000' || res.data.msg !== '') {
          return alert('發生錯誤，請重新送單');
        } else {
          this.getAccessToken({time: Date.now()})
          .then((res) => {
            // console.log(res)
            if (res) {
              this.sendOrderEilis({
                access: res.data.access_token,
                userID: this.eid.substr(2,),
                pickShop: this.shop,
                shopNo: this.shopNo,
                total: total,
                orderItems: this.checkList,
                redeemPoint: this.redeemP,
                orderNo: orderNum,
              })
              .then((res) => {
                this.loading = false;
                this.$createDialog({
                  type: 'alert',
                  showClose: false,
                  content: '你的訂單已成功送出，請前往訂單查看',
                  // text: '你的訂單已成功送出，請前往訂單查詢查看',
                  confirmBtn: {
                    text: '確定',
                    active: true,
                    disabled: false,
                  },
                  onConfirm: () => {
                    setTimeout(() => {
                      // if (this.shopCart.length > 0 || this.imCart.length > 0) {
                      //   this.shopCar = [];
                      //   this.imCart = []
                      // }
                      this.$emit('gotoList', '訂單');
                    },100)
                  }
                }).show()
              })
            }
          })
        }
      })
      .catch((res) => {
        alert(res);
      })
    },
    // 送出訂單
    openPayment() {
      if (this.checkList.length < 1) {
        const dia = this.$createDialog({
          type: 'confirm',
          title: '系統通知',
          content: '還未加入品項',
          icon: 'cubeic-alert',
          confirmBtn: {
            text: '確定',
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
        }).show()
        return dia;
      }
      this.payment = true;
    },
    closePayment() {
      this.payment = false;
    },
    beforeCheck(index) {
      // console.log(index);
      this.index = index;
      // this.checkList
      // console.log(this.checkList);
    },
    emptyCart() {
      this.$createDialog({
        type: 'confirm',
        title: '系統通知',
        content: '確認要清空購物車嗎？',
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          this.shopCar = [];
        },
        // onCancel: () => {
        //   this.$createToast({
        //     type: 'warn',
        //     time: 1000,
        //     txt: '点击取消按钮'
        //   }).show()
        // }
      }).show()
    },
    plus(idx) {
      // console.log(idx);
      this.index = idx;
      if (this.shopCart[this.index].num > 39) {
        return this.shopCart[this.index].num;
      } else {
        this.shopCart[this.index].num += 1;
        // this.tempArr.push(this.shopCart[this.index].item_price ? parseInt(this.shopCart[this.index].item_price) * 1 : parseInt(this.shopCart[this.index].item_price) * 1 )
        // console.log(this.tempArr);
      }
    },
    minus(idx) {
      // console.log(idx);
      this.index = idx;
      this.redeemP = 0;
      if (this.shopCart[this.index].num < 2) {
        this.$createDialog({
          type: 'confirm',
          title: '系統通知',
          content: '確認要清空此品項嗎？',
          icon: 'cubeic-alert',
          confirmBtn: {
            text: '確定',
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {
            this.shopCart.splice(this.index, 1);
          },
        }).show()
      } else {
        // this.tempArr.splice(this.shopCart[this.index], 1);
        // console.log(this.tempArr);
        this.shopCart[this.index].num -= 1;
      }
      // console.log(this.shopCart)
    },
  }
}
</script>

<style lang="scss" scoped>
  body {
  font: 300 14px/18px Roboto;
  // overflow-x:hidden;
  // overflow-y:hidden;
  // overflow: hidden;
  // height:100%;
}

*,
:after,
:before {
  box-sizing: border-box
}
  #layer{
    z-index: 100000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(181, 181, 181, 0.419);
  }
  .loading {
    z-index: 100000;
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    margin: 0 auto;
    position: fixed;
    top: 50%;
    left: 0;
    right: 0;
    // margin-top: -270px;
    width: 55px;
    height: 55px;
    color: #ffffff;
    border-radius: 5px;
    background-color: #717171;
    -webkit-text-fill-color: transparent;
  }
  .dia {
    z-index: 100;
    padding: 30px;
    width:100%;
    background-color: white;
    max-width: 300px;
    height: 180px;
    border-radius: 10px;
    border: 1px solid #F37423;
    margin: 100px auto;
  }
  .dia .cubeic-warn {
    transform: scale(1.4);
    border-radius: 50%;
    background-clip: text;
    // -webkit-text-fill-color: transparent;
    // border: 1px solid rgba(112, 88, 88, 0.877);
    color:#F57E28;
    padding: 15px;
  }
  .menu {
    // overflow-y: hidden;
    // overflow-x: hidden;
    z-index: 1;
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    width: 100%;
    height: 500px;
    max-width: 540px;
    background-color: #f9f9f9;
    // -webkit-overflow-scrolling: touch;
    // overflow-y: auto;
    // -ms-overflow-y: auto;
    // overflow: scroll;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .mock-up {
    min-width: 310px;
    height: 500px;
    margin: 0em auto;
    position: relative;
    overflow: hidden;
  }
  .overlay {
    // background: url('../img/louisa.png') ;
    // background-color: #F57E28;
    // background: url(https://raw.githubusercontent.com/arjunamgain/FilterMenu/master/images/header.jpg) no-repeat top /contain;
    position: absolute;
    left: -310px;
    transform: rotate(250deg);
    top: 0px;
    right: 0px;
    bottom: 120px;
    z-index: 1;
  }
  .overlay:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    // background: rgba(71, 32, 84, 0.5);
  }
  .box {
    height:100%;
    z-index: 10;
    position: relative;
    bottom: 450px;
    height: 600px;
    // height: 100%;
    width: 100%;
    min-width: 320px;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    -ms-overflow-y: auto;
    // overflow: scroll;
  }
  .box2 {
    // -webkit-overflow-scrolling: touch;
    z-index: 1000000;
    bottom: 13%;
    position:fixed;
    // bottom: 950px;
    margin: 0px auto;
    height: 50px;
    width: 100%;
    min-width: 350px;
  }
  .item-box2{
    background-color: #ffffff;
    padding-left: 0!important;
    padding-right: 0!important;
    // position: fixed;
    border-radius: 8px;
    margin: 0px auto;
    width: 94vw;
    padding: 5px 15px;
    height: 40px;
    // max-height: 250px;
    // border: 1px solid rgb(216, 216, 216);
    position: relative;
    // box-shadow: 3px 3px 3px -3px rgb(174, 174, 174),-3px 3px 3px -3px rgb(174, 174, 174);;
  }
  .item-box2 .list{
    padding-left: 0!important;
    padding-right: 0!important;
    text-align: left;
    height: 40px;
    width: 100%;
    margin: 0px;
    padding: 5px;
    // overflow-y: auto;
    // -webkit-overflow-scrolling: touch;
    padding-bottom: 0px;
  }
  .item-box2 .list .item {
    // overflow: auto;
    // -webkit-overflow-scrolling: touch;
    // overflow-y: auto;
    // -webkit-overflow-scrolling: touch;
    margin-top: 7px;
    display: flex;
    //overflow-y: auto;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    border-bottom: 1px solid rgba(210, 210, 210, 0.815);
    height: 50px;
    padding: 5px;
  }
  .item-box{
    background-color: #ffffff;
    padding-left: 0!important;
    padding-right: 0!important;
    // position: fixed;
    border-radius: 8px;
    margin: 0px auto;
    width: 94vw;
    padding: 5px 15px;
    height: 90%;
    overflow: hidden;
    overflow-y: auto;
    // max-height: 600px;
    // max-height: 250px;
    // border: 1px solid rgb(216, 216, 216);
    position: relative;
    // box-shadow: 3px 3px 3px -3px rgb(174, 174, 174),-3px 3px 3px -3px rgb(174, 174, 174);;
  }
  .item-box .list{
    padding-left: 0!important;
    padding-right: 0!important;
    text-align: left;
    height: 100px;
    width: 100%;
    margin: 0px;
    padding: 10px;
    // overflow-y: auto;
    // -webkit-overflow-scrolling: touch;
    padding-bottom: 0px;
  }
  .item-box .list .item {
    // overflow: auto;
    // -webkit-overflow-scrolling: touch;
    // overflow-y: auto;
    // -webkit-overflow-scrolling: touch;
    margin-top: 7px;
    display: flex;
    //overflow-y: auto;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    border-bottom: 1px solid rgba(210, 210, 210, 0.815);
    height: 75px;
    padding: 5px;
  }
  input[type='checkbox'] {
    cursor: pointer;
    position: relative;
    width: 1.3rem;
    height: 1.3rem;
    font-size: 0.9rem;
    visibility: hidden;
  }
  input[type='checkbox']::after {
    position: absolute;
    top: 0;
    left: 5px;
    // background-color: rgb(255, 255, 255);
    border: 1px solid #d3d3d3;
    color: #fff;
    width: 1.2rem;
    height: 1.2rem;
    display: inline-block;
    visibility: visible;
    padding-left: 0px;
    text-align: center;
    content: ' ';
    border-radius: 55%;
  }

  input[type='checkbox']:checked::after {
    content: '✔︎';
    position: absolute;
    color: #F57E28;
    font-size: 0.9rem;
    font-weight: 900;
  }
  .item-box .list .item .middle .title {
    margin-top: 4px;
    color: rgba(0, 0, 0, 0.851);
    font-size: 16px;
    font-weight: 500;
    width: 150px;
    display: flex;
    letter-spacing: 1px;
    justify-content: space-between;
  }
  .item-box .list .item .middle .entitle {
    margin-top: 5px;
    // transform: scale(0.8);
    margin-left: 1px;
    color: rgba(67, 67, 67, 0.851);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 1px;
  }
  .item-box .list .item .middle .money {
    margin-top: 18px;
    // transform: scale(0.8);
    margin-left: 2px;
    color: #F37423;
    font-size: 15px;
    font-weight: 800;
    letter-spacing: 1px;
  }
  .item-box .list .item .right {
    background-clip: text;
    font-size: 17px;
    // width: 70px;
    // -webkit-text-fill-color: transparent;
    // border: 1px solid rgba(112, 88, 88, 0.877);
    color:#F37423;
    padding: 0px;
    transform: translateX(-20px);
  }
  .bottom_right_button {
    // background-clip: text;
    font-size: 15px;
    border-radius:50px;
    width:90px;
    height: 35px;
    // -webkit-text-fill-color: transparent;
    // border: 1px solid rgba(112, 88, 88, 0.877);
    color: rgb(255, 255, 255);
    background-color: #F37423;
    padding: 0px;
  }
</style>
